<template>
    <div>
        <div class="bg-color">
            <b-container>
                    <WizardHolder/>
            </b-container> 
        </div>
    </div>
</template>

<script> 
    import WizardHolder from '@/components/frontend/registered/WizardHolder'

    export default {
        name: 'PublicViewWizard',
        components:{ 
            WizardHolder
        },
        data()  {
            return {

            }
        },
        created(){
            let disable_customer_field = false;
            if (this.$route.params.status) {
                let disable_customer_field = true;
            }
        }

    }
</script>

<style scoped>

    .bg {
        /* The image used for web */
        background: url("~@/assets/quick-quote-bg.png");

        /* Full height */
        height: 100%;
        overflow: hidden;
        /* Center and scale the image nicely */
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .bg-color {
        /*background-color: #f2f6fa;*/
    }

    @media (max-width: 767px) {
       .bg {
           overflow: scroll;
       }

        .app-footer {
            display: unset !important;
            text-align: center !important;
            bottom: 0!important;
            position: inherit;
            width: 100%;
        }
    }
</style>
